import type { CellColor } from "../types.ts";
import {
  BACKGROUND_COLOR,
  CELL_BORDER_RADIUS,
  getCellDisplayColor,
} from "./colors.ts";

export function drawTarget(
  ctx: CanvasRenderingContext2D,
  target: CellColor[][],
  width: number,
  height: number
) {
  const rows = target.length;
  const cols = target[0]?.length ?? 0;
  if (rows === 0 || cols === 0) return;

  const padding = 16;
  const maxCellW = (width - padding * 2) / cols;
  const maxCellH = (height - padding * 2) / rows;
  const cellSize = Math.floor(Math.min(maxCellW, maxCellH, 60));
  const gridW = cols * cellSize;
  const gridH = rows * cellSize;
  const offsetX = Math.floor((width - gridW) / 2);
  const offsetY = Math.floor((height - gridH) / 2);

  ctx.fillStyle = BACKGROUND_COLOR;
  ctx.fillRect(0, 0, width, height);

  const gap = 2;

  for (let r = 0; r < rows; r++) {
    for (let c = 0; c < cols; c++) {
      const color = target[r]![c]!;
      const x = offsetX + c * cellSize + gap;
      const y = offsetY + r * cellSize + gap;
      const w = cellSize - gap * 2;
      const h = cellSize - gap * 2;

      ctx.fillStyle = getCellDisplayColor(color);
      ctx.beginPath();
      ctx.moveTo(x + CELL_BORDER_RADIUS, y);
      ctx.lineTo(x + w - CELL_BORDER_RADIUS, y);
      ctx.quadraticCurveTo(x + w, y, x + w, y + CELL_BORDER_RADIUS);
      ctx.lineTo(x + w, y + h - CELL_BORDER_RADIUS);
      ctx.quadraticCurveTo(x + w, y + h, x + w - CELL_BORDER_RADIUS, y + h);
      ctx.lineTo(x + CELL_BORDER_RADIUS, y + h);
      ctx.quadraticCurveTo(x, y + h, x, y + h - CELL_BORDER_RADIUS);
      ctx.lineTo(x, y + CELL_BORDER_RADIUS);
      ctx.quadraticCurveTo(x, y, x + CELL_BORDER_RADIUS, y);
      ctx.closePath();
      ctx.fill();
    }
  }
}
